export const MARKETING_CAMPAIGNS = {
  PROMO: 'promo',
} as const;

export type IMarketingCampaigns =
  (typeof MARKETING_CAMPAIGNS)[keyof typeof MARKETING_CAMPAIGNS];

export const MARKETING_OFFER_CODES = {
  PAYMENT_EXIT: 'exit_intent',
  RETURN: 'return_offer',
  CANCELLATION: 'cancellation_offer',
  FREE_PERIOD_CANCEL: 'post_free_period_cancel_offer',
} as const;

export type IMarketingOfferCodes =
  (typeof MARKETING_OFFER_CODES)[keyof typeof MARKETING_OFFER_CODES];
